import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLayoutModule } from './default-layout/default-layout.module';

@NgModule({
  imports: [
    CommonModule,
    DefaultLayoutModule
  ],
  declarations: [
  ],
  exports: [
    DefaultLayoutModule
  ]
})
export class LayoutModule {
}
